import { makeAutoObservable } from "mobx"

export default class Document {
  id: number
  provider: string
  name: string
  documentTemplate?: any

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.name = props.name
    this.provider = props.provider
    this.documentTemplate = props.documentTemplate
  }
}
